import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Router } from "./Router";
import { fetchConfig, fetchCustomerInfo } from "./Services/MainService";
import { fetchOrders } from "./Services/OrderService";
import { useNavigate } from "react-router-dom";
import { clear } from "./Services/Storage";
import { WhatsAppFAB } from "./Components/WhatsAppFAB";

function App() {
  const dispatch = useDispatch();
  const loggedIn = useSelector((x) => x.LoggedIn);
  const config = useSelector((x) => x.Config);
  const [configLoading, setConfigLoading] = React.useState(true);
  const [stillLoading, setStillLoading] = React.useState(false);
  const [init, setInit] = React.useState(true);
  const navigate = useNavigate();
  React.useEffect(() => {
    fetchConfig().then(
      (res) => {
        setConfigLoading(false);
        dispatch({ type: "setConfig", payload: res });
      },
      (er) => {
        console.warn(er, "err while fetching config...");
        toast.error("Something went wrong while fetching configuration...");
      }
    );
  }, []);
  React.useEffect(() => {
    if (init) setInit(false);
    else {
      if (loggedIn && config) {
        setStillLoading(true);
        fetchCustomerInfo().then(
          (res) => {
            if (config?.customer_verification && !res.is_phone_verified) {
              navigate("/phone-verification", { replace: true });
            }
            dispatch({ type: "setCustomer", payload: res });
            fetchOrders({
              limit: config?.laundry_customer_maximum_order,
              offset: 1,
            }).then(
              (res) => {
                setStillLoading(false);
                dispatch({ type: "setOngoingOrders", payload: res.data });
              },
              (er) => {
                if (er && er.errors && er.errors.length > 0)
                  er.errors.forEach((x) => toast.error(x.message));
                else
                  toast.error(
                    "Something went wrong while fetching Ongoing Orders!"
                  );
              }
            );
          },
          (er) => {
            console.warn(er, "err while fetching customer...");
            if (er?.message?.toLowerCase().includes("unauthenticated")) {
              const c = config;
              dispatch({ type: "setToken", payload: null });
              dispatch({ type: "setOrderType", payload: null });
              dispatch({ type: "setService", payload: null });
              dispatch({ type: "setCategory", payload: null });
              dispatch({ type: "setCart", payload: [] });
              dispatch({ type: "setLoggedIn", payload: false });
              dispatch({ type: "setZone", payload: null });
              dispatch({ type: "setCustomer", payload: null });
              dispatch({ type: "setAddress", payload: null });
              dispatch({ type: "setAddresses", payload: null });
              dispatch({ type: "setOngoingOrders", payload: null });
              dispatch({ type: "setNote", payload: null });
              dispatch({ type: "setPickupDate", payload: null });
              dispatch({ type: "setDeliveryDate", payload: null });
              dispatch({ type: "setCoupon", payload: null });
              clear();
              sessionStorage.clear();
              localStorage.clear();
              dispatch({ type: "setConfig", payload: c });
              navigate("/", { replace: true });
            } else
              toast.error(
                "Something went wrong while fetching customer details..."
              );
            setStillLoading(false);
          }
        );
      }
    }
  }, [loggedIn, config]);
  return (
    <>
      {configLoading || stillLoading ? (
        <div className="config-loading">
          <img
            src="/assets/images/loader.gif"
            style={{ height: "70px", width: "70px", objectFit: "contain" }}
            alt=""
          />
        </div>
      ) : (
        <>
          <Router />
          <WhatsAppFAB />
          <ToastContainer />
        </>
      )}
    </>
  );
}

export default App;
